import { InputTextarea } from 'primereact/inputtextarea';
import { Message } from 'primereact/message';
import React from 'react';

export interface TextAreaProps {
  name: string; // Name of the input field
  onChange: (value: string) => void; // Function to handle changes
  value: string; // Current value of the input field
  disabled?: boolean; // Whether the input is disabled
  label?: string; // Label for the input field
  onBlur?: () => void; // Function to handle blur events
  placeholder?: string; // Placeholder text for the input field
  required?: boolean; // Whether the input is required
  rows?: number; // Number of rows for the textarea
  className?: string; // Additional class names for styling
  error?: boolean; // Whether there's an error for validation
}

const TextArea: React.FC<TextAreaProps> = ({
  name,
  onChange,
  value,
  disabled = false,
  label,
  onBlur,
  placeholder = 'Enter your text here...',
  required = false,
  rows = 3,
  className = '',
  error = false,
}) => {
  return (
    <div className={`form-group mb-2 ${className}`}>
      {label && (
        <label className="label-form mb-1">
          {label} {required && <span className="required-field">*</span>}
        </label>
      )}

      <InputTextarea
        className={`form-control w-full ${error ? 'p-invalid' : ''}`}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)} // Extract value from event
        rows={rows}
        disabled={disabled}
        onBlur={onBlur}
      />
      {error && <Message severity="error" text={error} />}
    </div>
  );
};

export default TextArea;
